import React, { useEffect } from 'react';
import { useTicketsStore } from '../store/ticketsStore';
import {
  FaqContainer,
  InsidePageContainer,
  PageContainer,
  TicketsCart,
} from '../common';
import Header from '../common/Header';
import { useHistory } from 'react-router-dom';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import MerchContainer from './sections/MerchContainer';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import {
  dataLayerPagesEnum,
  setVirtualPageDataLayer,
} from 'utils/dataLayerManager';

const Merchandising = ({ loggedUser, locale }) => {
  const theme = useTheme();
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const history = useHistory();
  const {
    fetchedMerchandising,
    productsInCart,
    merchInCart,
    isAddingCatalogueMode,
  } = useTicketsStore();

  useEffect(() => {
    setVirtualPageDataLayer(dataLayerPagesEnum.TICKETS_MERCHANDISING);
  }, []);

  const handleBack = () => history.push(`/`);
  const goToAssignTickets = () => history.push(`/assign-ticket`);
  const goToRecap = () => {
    useTicketsStore.setState({
      isAddingCatalogueMode: false,
    });
    history.push('/recap');
  };
  const intl = useIntl();
  const i18nMerch = translations.TicketsV2(intl).Merch;
  const i18nCommon = translations.TicketsV2(intl).Common;

  const isCartOpen =
    (productsInCart?.length &&
      productsInCart?.some((pro) => pro.quantity && pro.quantity > 0)) ||
    (merchInCart?.length &&
      merchInCart?.some((pro) => pro.quantity && pro.quantity > 0));
  const isApp = isCartOpen && window.location.pathname.includes('app');

  return (
    <PageContainer direction={'column'} forcePaddingBottom={isApp}>
      <InsidePageContainer>
        <Header loggedUser={loggedUser} backFn={handleBack} />
        <Stack direction={isLgDown ? 'column' : 'row'}>
          {fetchedMerchandising && fetchedMerchandising?.length ? (
            <MerchContainer
              fetchedMerch={fetchedMerchandising}
              locale={locale}
            />
          ) : (
            <Stack
              style={{
                width: isLgDown ? '100%' : '64%',
                ...(!isLgDown && {
                  paddingRight: '70px',
                }),
              }}
              gap={'25px'}
            ></Stack>
          )}
          {isCartOpen ? (
            <TicketsCart
              locale={locale}
              procideFn={() =>
                isAddingCatalogueMode ? goToRecap() : goToAssignTickets()
              }
              procideMsg={
                isAddingCatalogueMode
                  ? i18nCommon.backToRecap
                  : i18nCommon.proceedMsg
              }
            />
          ) : null}
        </Stack>
        <FaqContainer faqs={i18nMerch} />
      </InsidePageContainer>
    </PageContainer>
  );
};

export default Merchandising;
